import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from '@mui/material';

export default function DeleteTransactionDialog({
  transaction,
  formatAmount,
  formatDate,
  onCancel,
  onConfirm,
}) {
  const details = transaction
    ? [
        ['Asset', transaction.companyName],
        ['Type', transaction.type],
        ['Shares', transaction.shares],
        ['Price', formatAmount(transaction.price, transaction.currency)],
        ['Date', formatDate(transaction.timestamp)],
      ]
    : [];

  return (
    <Dialog fullWidth maxWidth="xs" open={!!transaction} onClose={onCancel}>
      <DialogTitle>Delete transaction?</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          This action cannot be undone. Cash will not be adjusted automatically.
        </DialogContentText>
        <Table size="small">
          <TableBody>
            {details.map(([label, value]) => (
              <TableRow key={label}>
                <TableCell sx={{ fontWeight: 'bold', border: 0 }}>
                  {label}
                </TableCell>
                <TableCell sx={{ border: 0 }}>{value}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="inherit">
          Cancel
        </Button>
        <Button
          onClick={() => onConfirm(transaction)}
          variant="contained"
          color="error"
        >
          Delete transaction
        </Button>
      </DialogActions>
    </Dialog>
  );
}
